import * as React from 'react';
import styles from './styles/stepStyles';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';
import Layout, { Content } from 'antd/lib/layout/layout';
import StepChecklistContainer from './StepChecklistContainer';
import { ChecklistItemPlacement, SubscriptionFeatureType } from '../types';
import { selectSortedSearchedApprovalsItems } from '../selectors/memoizedSelectors';
import { ReleaseEventsTimelineSection } from './releaseOverview/ReleaseTimelineSection';
import { ReleaseTimelineSectionContext } from './timelineEvents/EventsTimeline';
import { computeCompletedChecklistItemsCount } from '../helpers';
import Progress from 'antd/lib/progress';
import { runwayColors } from './styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import { PlanRestrictedFeatureWrapper } from './planRestrictions/PlanRestrictedFeatureWrapper';
import { ReleaseStepOrStepRunComponentProps } from '@/components/ValidatedRouteComponents';

const StepContentApprovals: React.FC<ReleaseStepOrStepRunComponentProps> = (props) => {
    const sortedAndSearchedApprovalItems = useSelector((state: RootState) =>
        selectSortedSearchedApprovalsItems(state, props.releaseId, props.stepRunComponentProps?.stepRunId),
    );

    const totalItemsCount = sortedAndSearchedApprovalItems.length;
    const completedCount = computeCompletedChecklistItemsCount(sortedAndSearchedApprovalItems);
    const completedPercent = (completedCount / totalItemsCount) * 100;

    return (
        <Layout>
            <PlanRestrictedFeatureWrapper
                feature={SubscriptionFeatureType.ApprovalsStep}
                shouldFakeDisabledState
                shouldGrayOutOnFakeDisabledState={false}
            >
                <Content
                    style={{
                        ...styles.innerContent,
                        paddingTop: 0,
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ paddingTop: 28, flex: 1 }}>
                            <Progress
                                percent={Math.round(completedPercent)}
                                strokeColor={runwayColors.statusGreen}
                                type="line"
                                format={(percent) => {
                                    return (
                                        <Text type="secondary">
                                            {percent}% complete ({completedCount} / {totalItemsCount})
                                        </Text>
                                    );
                                }}
                                style={{ maxWidth: 200 }}
                            />
                        </div>
                        <ReleaseEventsTimelineSection
                            orgId={props.orgId}
                            appId={props.appId}
                            releaseId={props.releaseId}
                            stepRunId={props.stepRunComponentProps?.stepRunId}
                            context={ReleaseTimelineSectionContext.ReleaseStep}
                            releaseStepType={props.releaseStepType}
                            shouldShowFullEventTimeline={props.shouldShowFullEventTimeline}
                        />
                    </div>

                    <StepChecklistContainer
                        {...props}
                        stepRunComponentProps={props.stepRunComponentProps}
                        items={sortedAndSearchedApprovalItems}
                        placement={ChecklistItemPlacement.Approvals}
                    />
                </Content>
            </PlanRestrictedFeatureWrapper>
        </Layout>
    );
};

export default StepContentApprovals;
